import { Kbd, Text } from "@mantine/core";
import { OS, useOs, useViewportSize } from "@mantine/hooks";
import { openSpotlight } from "@mantine/spotlight";
import EBSButton from "Components/Common/Button/Button";
import ConfirmationModal from "Components/Common/Modal/ConfirmationModal";
import { routes } from "Components/routes";
import useMyPrivilege from "Hooks/Privilege/useMyPrivilege";
import useDetails from "Hooks/Users/useDetails";
import { useAppSelector } from "Hooks/redux-hooks";
import { capitalizeLetters } from "Lib/CapitalizeLetters";
import { useTranslateHelper } from "Lib/useTranslateHelper";
import { toggleAppData } from "Redux/appDataSlice";
import { logoutUser } from "Redux/checkLoginSlice";
import { toggleLoading } from "Redux/loadingSlice";
import { toggle } from "Redux/toggleSlice";
import { imgUrl } from "Shared/BaseUrl";
import { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AlignJustified } from "tabler-icons-react";
import "./Navbar.css";

const NavbarUI = () => {
  const { t } = useTranslateHelper();
  const os: OS = useOs();
  const dispatch = useDispatch();
  const open = useAppSelector((state) => state.toggle.open);

  const navigate = useNavigate();

  const [showDropdown, setShowDropdown] = useState<boolean>(false);

  const [showModal, setShowModal] = useState<boolean>(false);

  const { width } = useViewportSize();

  const logout = async () => {
    dispatch(toggleLoading(true));
    dispatch(logoutUser());
    dispatch(toggleLoading(false));
  };

  const [myPrevList, setMyPrivList] = useState<string[]>([]);

  useMyPrivilege((data) => {
    var tempList = data.data.privileges.map((e) => e.privilege_key);
    setMyPrivList([...tempList]);
  });

  const getPermissions = (arr: string[]) => {
    for (const prev of arr) {
      if (myPrevList.includes(`manage_${prev}`)) {
        return true;
      }
    }
    return false;
  };

  const { data } = useDetails();

  useEffect(() => {
    if (data) {
      dispatch(toggleAppData({ userDetails: JSON.stringify(data.data.data) }));
    }
  }, [data, dispatch]);

  var imgComp = <></>;

  if (data) {
  }

  if (data) {
    const { image, name } = data.data.data;
    imgComp = (
      <div
        style={{ cursor: "default" }}
        onMouseLeave={() => {
          setShowDropdown(false);
        }}
        onMouseEnter={() => {
          setShowDropdown(true);
        }}
        className="d-flex align-items-center"
      >
        <>
          <div>{capitalizeLetters(name)}</div>
          <div style={{ position: "relative" }} className="">
            <img
              style={{ objectFit: "cover" }}
              className="nav-profile my-auto mx-2 mx-lg-3"
              alt="name"
              src={
                image
                  ? imgUrl + image
                  : `https://ui-avatars.com/api/?background=0f193a&color=fff&name=${name}`
              }
            />
            <div
              className={`rounded bg-white shadow p-1`}
              style={{
                position: "absolute",
                top: "90%",
                right: 0,
                width: "200px",
                transition: "0.5s all",
                transform: !showDropdown ? "translateY(100%)" : "translateY(0)",
                opacity: !showDropdown ? 0 : 1,
                pointerEvents: !showDropdown ? "none" : "all",
              }}
            >
              <DropText
                title={capitalizeLetters(name)}
                onClick={() => {
                  navigate(routes.account);
                }}
              />
              <DropText
                title={t("navbar.setting")}
                onClick={() => {
                  navigate(routes.settings);
                }}
              />
              <DropText
                title={t("navbar.businessSetting")}
                onClick={() => {
                  navigate(routes.businessSetting);
                }}
              />
              <DropText
                title={t("navbar.logout")}
                onClick={() => {
                  setShowModal(true);
                }}
              />
            </div>
          </div>
        </>
        <ConfirmationModal
          title={"Logout"}
          content={<p>Are you sure you want to logout?</p>}
          showModal={showModal}
          disable={true}
          onClose={() => {
            setShowModal(false);
          }}
          onConfirm={async () => {
            await logout();
          }}
        />
      </div>
    );
  }

  return (
    <header className="header py-3 px-4 shadow-sm">
      <div className="d-flex justify-content-between">
        <div className="d-flex align-items-center">
          <div
            onClick={() => {
              dispatch(toggle(!open));
            }}
            style={{ backgroundColor: "#f7f7f7" }}
            className="p-1 rounded-3 shadow-sm me-2 cursor-pointer"
          >
            <AlignJustified size={25} color="#0F193A" />
          </div>
          <div
            className="nav-search px-2 py-1 me-2"
            onClick={openSpotlight}
            style={{ cursor: "pointer" }}
          >
            <FaSearch className="nav-input-left" />
            <input
              readOnly
              className="nav-input"
              placeholder={t("navbar.search")}
            />
            <Kbd>
              {os === "windows" ? "Ctrl" : os === "macos" ? "Cmd" : "⌘"}
            </Kbd>{" "}
            + <Kbd>P</Kbd>
          </div>
        </div>
        {myPrevList ? (
          <div className={` flex-wrap ${width < 1050 ? "d-none" : "d-flex"}`}>
            {getPermissions(["users"]) && (
              <EBSButton
                onClick={() => {
                  navigate("/");
                }}
              >
                <img
                  alt=""
                  className="my-auto p-0"
                  src={`/assets/svg/dashboard.svg`}
                />
              </EBSButton>
            )}
            {getPermissions(["purchases", "sells", "stock"]) && (
              <EBSButton
                onClick={() => {
                  navigate("/add-product");
                }}
              >
                <img
                  alt=""
                  className="my-auto p-0"
                  src={`/assets/svg/product.svg`}
                />
              </EBSButton>
            )}
            {getPermissions(["purchases"]) && (
              <EBSButton
                onClick={() => {
                  navigate("/add-purchase");
                }}
              >
                <img
                  alt=""
                  className="my-auto p-0"
                  src={`/assets/svg/purchase.svg`}
                />
              </EBSButton>
            )}
            {getPermissions(["sells"]) && (
              <EBSButton
                onClick={() => {
                  navigate("/add-sale");
                }}
              >
                <img
                  alt=""
                  className="my-auto p-0"
                  src={`/assets/svg/sales.svg`}
                />
              </EBSButton>
            )}
            {getPermissions(["users"]) && (
              <EBSButton
                onClick={() => {
                  navigate("/actions");
                }}
              >
                <img
                  alt=""
                  className="my-auto p-0"
                  src={`/assets/svg/action.svg`}
                />
              </EBSButton>
            )}
          </div>
        ) : (
          <></>
        )}
        {imgComp}
      </div>
    </header>
  );
};

export default NavbarUI;

const DropText = ({
  onClick,
  title,
}: {
  onClick: () => void;
  title: string;
}) => {
  return (
    <Text
      className="mb-1"
      onClick={onClick}
      sx={{
        fontSize: 16,
        transition: "0.25s all",
        padding: "5px 10px",
        borderRadius: 8,
        fontWeight: 500,
        color: "#0f193a",
        "&:hover": {
          background: "#2465ea50",
          cursor: "pointer",
        },
      }}
    >
      {title}
    </Text>
  );
};
